<template>
    <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
        <div class="row">
            <div class="col-xl-12">
                <h2 class="fs-xxl fw-500 mt-4 text-white text-center">
                    {{ __t(this.main_title) }}
                    <small class="h3 fw-300 mt-3 mb-5 text-white opacity-60 hidden-sm-down">
                        {{ __t(this.main_description) }}
                    </small>
                </h2>
            </div>
            <div class="col-xl-6 ml-auto mr-auto">
                <div class="card p-4 rounded-plus bg-faded" v-if="cur_step == 'auth'">
                    <div>
                        <div class="form-group" v-for="field in this.fields_map">
                            <label class="form-label" :for="field.type">
                                {{ __t(field.title) }}
                            </label>

                            <input :type="field.input_type"
                                   :id="field.type"
                                   v-model="user_form[field.type]"
                                   class="form-control"
                            >
                        </div>

                        <div class="row no-gutters">
                            <div class="col-md-4 ml-auto text-right">
                                <button v-on:click="make_register" :disabled="!form_valid" class="btn btn-outline-primary block btn-lg mt-3 waves-effect waves-themed">
                                    {{ __t('NEXT') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card rounded-plus bg-faded" v-if="cur_step == 'finish'">
                    <div class="p-4 mt-5 mb-5">
                       <a class="btn-outline-primary" :href="this.finish_url" target="_blank"> {{__t('URL')}}</a>
                    </div>
                </div>

                <div class="card rounded-plus bg-faded" v-if="cur_step == 'import'">
                    <div class="list_mem_create p-4">
                        <div class="panel-container show" v-if="work_obj.isLoaded">
                            <div class="panel-content">
                                <table class="table table-stripped" v-if="work_obj.isLoaded">
                                    <thead>
                                    <tr>
                                        <th width="35px">#</th>
                                        <th>{{ __t('FEED_TYPE') }}</th>
                                        <th>{{ __t('FEED_QTY') }}</th>
                                        <th>{{ __t('FEED_STATUS') }}</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <template v-for="(item_feed,type) in this.feed">
                                        <tr>
                                            <td>
                                                {{ item_feed.number }}
                                            </td>

                                            <td>
                                                {{ __t(item_feed.human_name) }}
                                            </td>

                                            <td>
                                                <b-badge variant="success">
                                                    {{ item_feed.count_ok }}
                                                </b-badge>
                                                /
                                                <b-badge variant="danger">
                                                    {{ item_feed.count_err }}
                                                </b-badge>
                                                /
                                                <b-badge variant="info">
                                                    {{ item_feed.count_all }}
                                                </b-badge>

                                            </td>
                                            <td>
                                                {{ item_feed.status }}
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import { push_api } from "../../libs/api_builder";

export default {
    name: "pwa_generate",
    data() {
        return {
            is_auth: false,
            is_input_ok: false,
            user_form: {
                email       : "",
                password    : "",
                market_url  : "",
            },

            cur_step : 'auth',

            finish_url : "",
            step_import : {
                'user' : {
                    "token" : "",
                },
                'market' : "",
                'market_url' : "",
            },

            prov_id : 63,

            //Feed Data
            options: {
                batchSize: 3,
                retry: false
            },

            timer: {
                seconds: 0,
                interval: null,
            },

            work_obj: {
                step_name: "",
                isRunning: false,
                isSyncRun:false,
                isSynced: false,
                isLoaded: false,
                isFileFeed  : false,
                request_cancel: null,
                token: null,
                is_in_socket : false,
            },
            feed: [],
            cur_org_id : "",

        }
    },

    methods: {

        async make_register() {
            _core.showloading();
            let send_data = this.user_form;
            await api.post('/api/v2/user/pwa/register', send_data).then(({data}) => {
                _core.hideloading();
                if (data.status === "operation_success") {
                    this.step_import = data.data;
                    this.cur_step = 'import';
                    this.make_import();

                }
                else {
                    EventBus.$emit('show_toast', {err: this.__t('ERR'), type: "danger", title: "Нет"})
                }
            }).catch(({response}) => {
                _core.hideloading();
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async make_import() {

            window.pos_api = push_api('pos',{
                'token' : this.step_import.user.token,
                'pos': 'https://pos.getorder.biz/api/v1/',
            })

            _core.showloading();

            pos_api.post('/pos/63/organizations/'+ this.step_import.market +'/feed',{
                "menu_type" : 'default',
                "market_in" : this.step_import.market,
                "params" : [
                    {
                        "type" : "url",
                        "value" : this.step_import.market_url
                    }
                ],
            }).then(({data}) => {
                _core.hideloading();
                if (data.status === "operation_success") {

                    this.is_load = false;
                    this.feed = data.data;
                    this.work_obj.isLoaded = true;
                    this.work_obj.isRunning = false;

                    this.cur_org_id = this.step_import.market;

                    if(this.feed.hasOwnProperty("organizations")) {
                        let orgs = this.feed.organizations.items;
                        if(orgs.length === 1) {
                            this.cur_org_id = orgs[0].id;
                        }
                    }

                    console.log(this.cur_org_id);
                    this.sync_menu();
                }
            }).catch(({response}) => {
                _core.hideloading();
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
            });
        },

        async buildPwaLocation() {
            _core.showloading();
            let main_api = push_api('pos',{
                'token' : this.step_import.user.token,
                'pos': 'https://api.getorder.biz/api/v2/',
            })

            await main_api.put('/user/pwa/register/' + this.step_import.market,{
                "market_url" : this.step_import.market_url,
                'org_uniq' : this.cur_org_id
            }).then(({data}) => {
                _core.hideloading();
                if (data.status === "operation_success") {
                    this.finish_url = data.data;
                    this.cur_step = 'finish';
                }
                else {
                    EventBus.$emit('show_toast', {err: this.__t('ERR'), type: "danger", title: "Нет"})
                }
            }).catch(({response}) => {
                _core.hideloading();
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });



        },


        //FEED_LOADER

        sync_menu() {
            let self = this;
            self.work_obj.isRunning = true;

            // Create a promise to start the chain
            let promise = Promise.resolve('OK');
            for (const [key, value] of Object.entries(self.feed)) {
                promise = promise.then((res) => {
                    return self.build_promise(key,value)
                });
            }

            promise.catch((response) => {
                self.work_obj.isRunning = false;
                EventBus.$emit('show_toast', {
                    err: "ERR",
                    type: "danger",
                    title: "operation_fail"
                })
            });
            promise.then((response) => {
                console.log('finish',response);
                self.work_obj.isRunning = false;
                this.buildPwaLocation();
            })
        },

        unmark_old(type) {
            return pos_api.patch('/pos/' + this.prov_id + '/organizations/' +  this.cur_org_id + "/" + type, {
                'type' : type,
            });
        },

        build_promise(idx,item)
        {
            let self = this;
            return this.unmark_old(idx).then((res) => {
                self.feed[idx].status = 'working';
                return this.make_batch(idx);
            }).then((res) => {
                console.log(res);
                self.feed[idx].status = 'finish';
                return res;

            }).catch((response) => {
                self.feed[idx].status = 'error';
                EventBus.$emit('show_toast', {
                    err: "ERR:" + idx,
                    type: "danger",
                    title: "operation_fail"
                })
                throw new Error(response);
            });
        },

        async batchAxiosPromises(_items, cur_feed ,fn, callback) {
            let promiseChainResult = Promise.resolve();
            let self = this;
            let chunked_items = _items.chunk_inefficient(
                this.options.batchSize
            );
            let promiseChain = Promise.resolve();

            chunked_items.map(function (entity) {
                function getCurrentItem(item) {
                    return fn(item,cur_feed)
                        .then(({data}) => {
                            self.__l(item, "info", "SuccessFN -> Done");
                            if (callback != null) {
                                callback("OK");
                            }
                        }).catch(err => {
                            self.__l(item, "warn", "ErrorFN -> ERR");
                            if (callback != null) {
                                callback("ERR");
                            }
                        })
                }

                const makeNextPromise = (entity) => () => {
                    const allPromises = entity.map(item => getCurrentItem(item));
                    return Promise.all(allPromises).then(res => {
                        self.__l({}, "ok", "Chunk -> Done")
                    });
                };
                promiseChain = promiseChain.then(makeNextPromise(entity))
            });
            return promiseChain;
        },

        make_batch(idx) {
            let self = this;
            let cur_feed = self.feed[idx];
            return this.batchAxiosPromises(cur_feed.items, cur_feed, this.put_feed_item, res => {
                this.__l(res, "ok", "SYNC  -> " + idx);
                if (res === "OK") {
                    cur_feed.count_ok++;
                } else {
                    cur_feed.count_err++;
                }
            });
        },

        async put_feed_item(item,cur_feed) {
            console.log(cur_feed);
            let cur_type = cur_feed.cur_type;
            cur_type = cur_type.slice(0,-1);

            if(cur_type == 'categorie') {
                cur_type = 'category';
            }

            if(cur_type == 'citie') {
                cur_type = 'city';
            }

            if(cur_type == 'organization') {
                return pos_api.put('/pos/' + this.prov_id + '/organization', {
                    "store_item": item,
                });
            }

            return pos_api.put('/pos/' + this.prov_id + '/organizations/' +  this.cur_org_id +"/"+ cur_type, {
                "store_item": item,
            });
        },


    },

    computed : {
        fields_map () {
            return [
                {
                    'type': 'email',
                    'input_type': "email",
                    'title': 'EMAIL'
                },

               {
                    'type': 'phone',
                    'input_type': "text",
                    'title': 'PHONE'
                },

                {
                    'type': 'market_url',
                    'input_type': "text",
                    'title': 'MARKET_URL',
                },
            ];
        },

        form_valid() {
            const email = this.user_form.email?.trim();
          //  const password = this.user_form.password;
            const url = this.user_form.market_url?.trim();

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const urlRegex = /^(https?:\/\/)?([\w\-]+\.)+[\w\-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;

            return (
                emailRegex.test(email) &&
             //   password.length >= 6 &&
                urlRegex.test(url)
            );
        },

        main_title () {
            if(this.cur_step == 'import') {
                return 'REGISTER_IMPORT';
            }

            return 'REGISTER_TITLE';
        },

        main_description () {

            if(this.cur_step == 'import') {
                return 'REGISTER_IMPORT_DESCRIPTION';
            }

            return 'REGISTER_DESCRIPTION'
        }
    }
}
</script>


<style scoped>

</style>
